import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { DTC_DTCC_BASE_PATH } from '../../../../../../../../features/dtc/files/v1/dtc-file-request-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'clearing-vendor-dtcc',
        label: 'DTCC',
        to: DTC_DTCC_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
